module.exports = __webpack_public_path__ + "static/media/care.737eb71f.svg";